var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-overlay',{ref:"customOverlay",class:{sample: true, active: _vm.active},attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}},[_c('div',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }